import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, AnyAction } from "redux";
import thunk, { ThunkMiddleware } from "redux-thunk";

import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/pro-regular-svg-icons";

import reducer from "redux/reducers/index";
import App from "app";
import Loader from "components/loader/loader";
import StripeProvider from "components/StripeProvider";
import { HelmetProvider } from "react-helmet-async";

import "public/scss/_variables.scss";
import "public/scss/_global.scss";
import "./i18n";
import "./index.css";
import { websiteBuilderMiddleware } from "redux/reducers/websiteBuilder/websiteBuilderMiddleware";
import { emailBuilderMiddleware } from "redux/reducers/emailBuilder/emailBuilderMiddleware";

library.add(far);

export const store = createStore(
  reducer,
  applyMiddleware(
    thunk as ThunkMiddleware<any, AnyAction>,
    websiteBuilderMiddleware,
    emailBuilderMiddleware,
  ),
);

export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;

const Root = () => {
  return (
    <Provider store={store}>
      {/* 👇 Wrap your app with the new dynamic provider */}
      <StripeProvider>
        <Loader />
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </StripeProvider>
    </Provider>
  );
};

render(<Root />, document.getElementById("root"));
